import React from 'react';
import { StepProps } from '../MultiStepModal';

function CertificateDetailsStep({ data, onDataChange }: StepProps) {
  const handleInputChange = (field: string, value: string) => {
    onDataChange({ [field]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Certificate Details</h3>
        <p className="step-form-subtitle">Generate a new safety certificate</p>
      </div>

      <form onSubmit={handleSubmit} className="step-form-content">
        <div className="form-group">
          <label className="form-label">Certificate Type *</label>
          <select
            className="form-select"
            value={data.type || ''}
            onChange={(e) => handleInputChange('type', e.target.value)}
            required
          >
            <option value="">Select certificate type</option>
            <option value="GAS_SAFETY">Gas Safety Certificate</option>
            <option value="ELECTRICAL">Electrical Certificate</option>
            <option value="BOILER_SERVICE">Boiler Service Certificate</option>
            <option value="LANDLORD_SAFETY">Landlord Safety Certificate</option>
            <option value="INSTALLATION">Installation Certificate</option>
            <option value="OTHER">Other</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Certificate Number</label>
          <input
            type="text"
            className="form-input"
            placeholder="Leave blank to auto-generate"
            value={data.certificateNumber || ''}
            onChange={(e) => handleInputChange('certificateNumber', e.target.value)}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Issue Date *</label>
            <input
              type="date"
              className="form-input"
              value={data.issueDate || new Date().toISOString().split('T')[0]}
              onChange={(e) => handleInputChange('issueDate', e.target.value)}
              max={new Date().toISOString().split('T')[0]}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Expiry Date *</label>
            <input
              type="date"
              className="form-input"
              value={data.expiryDate || ''}
              onChange={(e) => handleInputChange('expiryDate', e.target.value)}
              min={data.issueDate || new Date().toISOString().split('T')[0]}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Inspection Notes</label>
          <textarea
            className="form-textarea"
            placeholder="Details of inspection, findings, recommendations..."
            value={data.notes || ''}
            onChange={(e) => handleInputChange('notes', e.target.value)}
            rows={3}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Remedial Actions Required</label>
          <textarea
            className="form-textarea"
            placeholder="List any actions that need to be taken..."
            value={data.remedialActions || ''}
            onChange={(e) => handleInputChange('remedialActions', e.target.value)}
            rows={2}
          />
        </div>
      </form>
    </div>
  );
}

export default CertificateDetailsStep;
